import encryptServer from '@/request/encryptRequest.js';

// 通过注册证号精确查询
export const registerProductDetail = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/registerProduct/detail', data);

export const updateRegisterProduct = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/registerProduct/update', data);

export const addRegisterProduct = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/registerProduct/add', data);

// 通过注册证号分页获取
export const registerProductList = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/registerProduct/pageList', data);

// 拉取小紫ERP注册证号
export const pullXiaoZiErp = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/registerProduct/pullXiaoZiErp', data);
